<template lang="pug">
.handler
    .handler__header(
        :class='{ "handler__header--open": handlerAberto }',
        @click='gatilhoColapsar'
    )
        h3.handler__title {{ titulo }}
        i.el.el-icon-arrow-down.handler__arrow(
            :class='{ "handler__arrow--open": handlerAberto }'
        )
    .handler__body(:class='{ "handler__body--open": handlerAberto }')
        slot
</template>

<script>
export default {
    name: 'Handler',
    props: {
        titulo: {
            type: String,
            default: ''
        },
        aberto: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            handlerAberto: this.aberto
        };
    },
    methods: {
        gatilhoColapsar() {
            this.handlerAberto = !this.handlerAberto;
            this.$emit('update:aberto', this.handlerAberto);
        }
    }
};
</script>

<style lang="scss">
.handler {
    display: flex;
    flex-direction: column;
    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        &--open {
            border-bottom: 1px solid $default-border-color;
            padding: 12px 16px 16px;
        }
    }
    &__arrow {
        color: #000;
        font-size: 18px;
        cursor: pointer;
        transition: transform 0.3s ease-in-out;

        &--open {
            transform: rotate(180deg);
        }
    }
    &__title {
        font-weight: bold;
        font-size: 16px;
    }
    &__body {
        display: none;
        padding: 16px;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
        &--open {
            display: block;
            opacity: 1;
        }
    }
}
</style>
